/* src/app/core/pages/home/home.page.scss */
ion-card-title {
  --color: hwb(32 32% 0%);
  text-align: center;
}
ion-card-subtitle {
  --color: #54d4c1;
  text-align: center;
  font-weight: 600;
}
ion-card-subtitle ion-label:hover {
  color: #44a899;
  cursor: pointer !important;
}
ion-card-content {
  text-align: center;
}
/*# sourceMappingURL=home.page.css.map */
